import React from 'react';
import FontW7 from "../Font/FontW7"
import FontW9 from "../Font/FontW9"
import {withStyles, Grid} from "@material-ui/core"

const style = theme => ({
    root: {
        minHeight: '100vh',
        backgroundImage: 'url(img/slide/background_slide.png) !important',
        backgroundPosition: 'center !important',
        backgroundRepeat: 'no-repeat !important',
        backgroundSize: 'cover !important',
        alignItems: 'center',
        display: 'flex',
        position: 'relative',
    },
    fixScroll: {
        position: 'absolute',
        top: 0,
        [theme.breakpoints.down('xs')]: {
            top: 30
        }
    },
    fixContainer:{
        ['@media (min-width:960px)']: {
            maxWidth: '100%',
        },
        ['@media (min-width:1200px)']: {
            maxWidth: 1100,
        },
        height: '100%',
        alignContent: 'space-around',
        margin: '0 auto',
    },
    fixTitle: {
        marginBottom: 0,
        paddingTop: 50,
        ['@media (min-width:960px)']: {
            paddingBottom: 20,
        },
        ['@media (min-width:1200px)']: {
            paddingBottom: 50,
        },
        [theme.breakpoints.down('sm')]: {
            paddingBottom: 20,
        },
    },
    fix32: {
        fontSize: 28,
    },
    fix48: {
        fontSize: 40,
    },
    boxContent: {
        ['@media (min-width:960px)']: {
            maxWidth: '100%',
            flexBasis: '100%',
            flexGrow: '0',
        },
        ['@media (min-width:1200px)']: {
            maxWidth: '50%',
            flexBasis: '50%',
            flexGrow: '0',
        },
    },
    content: {
        fontSize: 18,
        lineHeight: '28px',
        marginLeft: 50,
        ['@media (min-width:960px)']: {
            marginBottom: 20,
        },
        ['@media (min-width:1200px)']: {
            marginBottom: 80,
        },
        textAlign: 'justify',
        [theme.breakpoints.down('sm')]: {
            marginBottom: 20,
        },
        [theme.breakpoints.down('xs')]: {
            margin: '0 10px',
        },
    },
    boxInfomation: {
        display: 'flex',
        alignItems: 'flex-end',
        [theme.breakpoints.down('sm')]: {
            justifyContent: 'center',
        },
        ['@media (min-width:960px)']: {
            maxWidth: '100%',
            flexBasis: '100%',
            flexGrow: '0',
            justifyContent: 'center',
        },
        ['@media (min-width:1200px)']: {
            maxWidth: '50%',
            flexBasis: '50%',
            flexGrow: '0',
            justifyContent: 'flex-end',
        },
    },
    sublink: {
        textAlign: 'center',
        position: 'unset',
        ['@media (min-width:1200px)']: {
            paddingRight: 50,
        },
        paddingBottom: 80,
        [theme.breakpoints.down('sm')]: {
            paddingBottom: 80,
            paddingRight: 0,
        },
        [theme.breakpoints.down('xs')]: {
            paddingBottom: 50,
        },
    },
    fixSubW9:{
        fontSize: 59,
        marginTop: 0,
        marginLeft: -68,
        marginRight: -68,
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            marginRight: 0,
        },
        [theme.breakpoints.down('xs')]: {
            textIndent: -25,
            wordSpacing: -5,
            fontSize: 45,
        },
    },
    fontContact: {
        fontSize: 24,
        color: 'white',
        marginTop: -75,
        marginLeft: 100,
        [theme.breakpoints.down('xs')]: {
            marginTop: -65,
            fontSize: 18,
            marginLeft: 75,
        },
        '&& span' : {
            fontSize: 12,
            [theme.breakpoints.down('xs')]: {
                fontSize: 10,
            },
        },
    },
    imgContact: {
        width: 420,
        [theme.breakpoints.down('xs')]: {
            width: 310,
        },
    },
})

function Slider2(props) {
    const {classes, content} = props
    return (
       <Grid
          id="section-2"
          className={classes.root}
       >
           <span className={classes.fixScroll} data-scroll-index="1"/>
           <Grid
              container
              className={classes.fixContainer}
           >
               <Grid
                  item xs={12}
                  className={"wow fadeInUp " + classes.fixTitle}
                  data-wow-delay=".6s"
               >
                   <h3
                      data-position="centerCenter"
                      // data-vertical="-100"
                      data-horizontal="0"
                      data-show-transition="up"
                      data-show-duration="1000"
                      data-show-delay="500"
                      data-width="100%"
                      data-hide-transition="down"
                      style={{
                          textAlign: 'center',
                          paddingBottom: 10,
                          marginTop: 0,
                          marginBottom: 0,
                      }}
                   >
                       <FontW7 className={classes.fix32}>Inner Resource Development</FontW7>
                   </h3>
                   <h2
                      data-position="centerCenter"
                      // data-vertical="0"
                      data-horizontal="0"
                      data-show-transition="up"
                      data-show-duration="1000"
                      data-show-delay="500"
                      data-width="100%"
                      data-hide-transition="down"
                      style={{
                          textAlign: 'center',
                          marginTop: 0,
                          marginBottom: 0,
                      }}
                   >
                       <FontW9 className={classes.fix48}>
                           「内なる未開の地」<br/>
                           を開拓する旅路。
                       </FontW9>
                   </h2>
               </Grid>
               <Grid
                  item
                  md={6}
                  xs={12}
                  className={
                      "wow fadeInLeft "
                      + classes.boxContent
                  }
                  data-wow-delay=".4s"
               >
                   <p
                      className={
                          "sp-layer subtitle "
                          + classes.content
                      }
                      data-position="centerCenter"
                      data-vertical="50"
                      data-horizontal="0"
                      data-show-transition="up"
                      data-show-duration="1000"
                      data-show-delay="700"
                      data-width="80%"
                      data-hide-transition="down"
                      style={{position: 'unset'}}
                   >
                       <FontW7>
                           {content}
                       </FontW7>
                   </p>
               </Grid>
               <Grid
                  item
                  md={6}
                  xs={12}
                  className={
                      "wow fadeInRight "
                      + classes.boxInfomation
                  }
                  data-wow-delay=".6s"
               >
                   <div
                      className={
                          "sp-layer sublink "
                          + classes.sublink
                      }
                      // data-position="bottomRight"
                      data-vertical="200"
                      data-horizontal="0"
                      data-show-transition="up"
                      data-show-duration="1000"
                      data-show-delay="900"
                      data-hide-transition="down"
                   >
                       <h3
                          style={{fontSize: 26, marginBottom: 0, marginTop: 0}}
                       >
                           <FontW7>無料オンライン講座（全１７回）</FontW7>
                       </h3>
                       <h2
                          className={classes.fixSubW9}
                       >
                           <FontW9>「Who am I?」</FontW9>
                       </h2>
                       <a
                          href="https://line.me/R/ti/p/%40bdi5394s"
                          target="_blank" rel="noopener noreferrer"
                       >
                           <img src='img/lineButton.png' alt='' className={classes.imgContact}/>
                           <p
                              className={classes.fontContact}
                           >
                               に登録して、無料受講する。<br/>
                               <span>※いつでも簡単に停止できます。(通知オフ機能)</span>
                           </p>
                       </a>
                   </div>
               </Grid>
           </Grid>
       </Grid>
    )
}

export default withStyles(style)(Slider2)
